import { render, staticRenderFns } from "./washDetails.vue?vue&type=template&id=1b490f86&scoped=true&"
import script from "./washDetails.vue?vue&type=script&lang=js&"
export * from "./washDetails.vue?vue&type=script&lang=js&"
import style0 from "./washDetails.vue?vue&type=style&index=0&id=1b490f86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b490f86",
  null
  
)

export default component.exports